import React from 'react';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import './App.css';

const App = () => {
  // Konfiguracja Firebase
  const firebaseConfig = {
    apiKey: "AIzaSyDAE9_dUkXHQkLJp8URP3eztNZlCFF6Wiw",
    authDomain: "historia-edukacja-app.firebaseapp.com",
    projectId: "historia-edukacja-app",
    storageBucket: "historia-edukacja-app.firebasestorage.app",
    messagingSenderId: "918677513905",
    appId: "1:918677513905:web:46a1f9825dca649d4da490",
    measurementId: "G-Z4RPHNV7TL"
  };

  // Inicjalizacja Firebase
  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);

  // Lista linków - tutaj możesz dodać swoje linki
  const links = [
    {
      title: "Aplikacja na Google Play",
      url: "https://play.google.com/store/apps/details?id=pl.preclaw.historiasp&hl=en",
      description: "Pobierz aplikację MZLearning na Androida",
      icon: "📱"
    },
    {
      title: "Aplikacja na App Store",
      url: "https://apps.apple.com/pl/app/mzlearning/id6758734996",
      description: "Pobierz aplikację MZLearning na iOS",
      icon: "📱"
    },
    {
      title: "Książki Magdaleny Zelmańskiej-Recław",
      url: "https://www.empik.com/szukaj/produkt?q=magdalena%20zelmanska&qtype=basicForm",
      description: "Zobacz wszystkie książki autorki",
      icon: "📚"
    },
    {
      title: "Instagram",
      url: "https://www.instagram.com/mz_learning_know",
      description: "Śledź nas na Instagramie",
      icon: "📸"
    },
    {
      title: "Youtube",
      url: "https://www.youtube.com/@mzlearning3257",
      description: "Notatki, ksiazki w wersji audio",
      icon: "📸"
    },
    {
      title: "Buy Me a Coffee",
      url: "https://buycoffee.to/mzlearning",
      description: "Wesprzyj naszą pracę",
      icon: "☕"
    },
    {
      title: "Kontakt Email",
      url: "mailto:mag.zelmanska@gmail.com",
      description: "Napisz do nas",
      icon: "✉️"
    }
  ];

  return (
    <div className="link-bio-container">
      <div className="content-wrapper">
        {/* Logo i nazwa */}
        <div className="header-section">
          <img src="logo_mz.png" alt="MZ Learning Logo" className="main-logo" />
          <h1 className="main-title">MZ LEARNING</h1>
          <p className="subtitle">Nauka na miarę Twoich potrzeb</p>
        </div>

        {/* Lista linków */}
        <div className="links-section">
          {links.map((link, index) => (
            <a
              key={index}
              href={link.url}
              className="link-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="link-content">
                <div className="link-text">
                  <div className="link-title">{link.title}</div>
                  {link.description && (
                    <div className="link-description">{link.description}</div>
                  )}
                </div>
                {link.icon && (
                  <div className="link-icon">{link.icon}</div>
                )}
              </div>
            </a>
          ))}
        </div>

        {/* Footer */}
        <div className="footer-section">
          <p>© {new Date().getFullYear()} MZ Learning</p>
        </div>
      </div>
    </div>
  );
};

export default App;

